import React from 'react';
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import {Box, CircularProgress, Typography} from "@mui/material";
import { DeleteRounded } from "@mui/icons-material";
import {translateKey} from "../../../config/values";
import {LoadingButton} from "@mui/lab";

const GetConfirmationButton = ({
                                   children,
                                   question,
                                   size,
                                   icon,
                                   color,
                                   buttonColor,
                                   tooltip,
                                   className,
                                   style,
                                   variant,
                                   startIcon,
                                   loading,
                                   handleAction
                               }) => {
    return (
        <PopupState variant="popover" popupId="demo-popup-popover">
            {(popupState) => (
                <div className="floated-delete-button">
                    <Tooltip title={tooltip} arrow>
                        <LoadingButton
                            variant={variant}
                            size={size}
                            color={buttonColor}
                            style={style}
                            className={className}
                            startIcon={startIcon}
                            {...bindTrigger(popupState)}
                            loading={loading}
                        >
                            {children}
                        </LoadingButton>

                    </Tooltip>
                    <Popover
                        elevation={1}
                        {...bindPopover(popupState)}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <Box p={1}>
                            <Typography>
                                {question || translateKey('areYouSure')}
                                <Button
                                    color={color || "error"}
                                    style={{marginRight: 5, marginLeft: 5 }}
                                    startIcon={icon || <DeleteRounded />}
                                    onClick={() => {
                                        handleAction();
                                        popupState.close();
                                    }}
                                >
                                    {translateKey('yes')}
                                </Button>

                            </Typography>
                        </Box>
                    </Popover>
                </div>
            )}
        </PopupState>
    );
};

export default GetConfirmationButton;
